/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MeterUsageWindow = {
  /**
   * Inclusive UTC midnight window boundary
   */
  from: Date;
  /**
   * Exclusive UTC midnight window boundary
   */
  to: Date;
};

/** @internal */
export const MeterUsageWindow$inboundSchema: z.ZodMiniType<
  MeterUsageWindow,
  unknown
> = z.object({
  from: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
  to: z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
});

export function meterUsageWindowFromJSON(
  jsonString: string,
): SafeParseResult<MeterUsageWindow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MeterUsageWindow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MeterUsageWindow' from JSON`,
  );
}
